import { useCallback, useState, type MouseEvent } from 'react';
import { useLastAppError } from '../errors/LastAppErrorContext';
import { useI18n } from '../i18n';
import { LastErrorInspectPanel } from './LastErrorInspectPanel';
import styles from './LastErrorInspectTrigger.module.css';

export function LastErrorInspectTrigger() {
  const { t } = useI18n();
  const { lastError, clearError } = useLastAppError();
  const [open, setOpen] = useState(false);
  const label = t('header.lastErrorInspect');

  const onOpen = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const onClear = useCallback(() => {
    clearError();
    setOpen(false);
  }, [clearError]);

  return (
    <>
      <button
        type="button"
        className={styles.iconBtn}
        aria-label={label}
        title={label}
        onClick={onOpen}
      >
        <LastErrorMark />
      </button>
      {open ? (
        <LastErrorInspectPanel error={lastError} onClose={onClose} onClear={onClear} />
      ) : null}
    </>
  );
}

function LastErrorMark() {
  return (
    <span className={styles.mark} aria-hidden>
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="9" />
      </svg>
      <span className={styles.letter}>e</span>
    </span>
  );
}
